export const LOA = (() => {
  // in parent window:
  /*
  bindEvent(window, 'message', function (e) {
              document.findElementById("iframe-id").height = e.data;
          });
          */

  let _floatingKeyboard: HTMLDivElement;
  let _lastInput: HTMLInputElement | null;

  console.log("LOA init");

  function onWindowResize() {
    var content = document.getElementById("content");
    if (content) {
      var height = "" + (content.offsetHeight + 50);
      window.parent.postMessage(height, "*");
    }
  }

  function init() {
    window.onresize = onWindowResize;
    onWindowResize();

    prepper();

    // on prof-test-grade
    /* if (typeof update==="function") {
      update();
    }

    // prof-test-generate
    if (typeof profTestCreate==="function") {
      profTestCreate();
    } */
  }

  function prepper() {
    document.body.onclick = (evt) => {
      //console.log("body click");
      if (_floatingKeyboard) _floatingKeyboard.remove();
      _lastInput = null;
    };

    document
      .querySelectorAll(
        ".prof-test-question input[type='text'], .prof-test-question textarea"
      )
      .forEach((input) => {
        const inp = input as HTMLInputElement;

        inp.onclick = (evt) => {
          // prevent body click
          evt.stopImmediatePropagation();
        };

        inp.onkeydown = (evt) => {
          if (evt.keyCode === 13 || evt.keyCode === 10) {
            evt.returnValue = false;
          }
        };

        inp.onfocus = (evt) => {
          if (input === _lastInput) return;
          if (_floatingKeyboard) _floatingKeyboard.remove();
          _floatingKeyboard = _keyboard(inp);
          inp.parentElement?.append(_floatingKeyboard);
          _lastInput = inp;
        };
      });
  }

  function _keyboard(input: HTMLInputElement) {
    var kbd = document.createElement("div");
    kbd.className = "floating-keyboard";
    ["á", "é", "í", "ó", "ú", "ý", "þ", "æ", "ö", "ð"].forEach((char, i) => {
      var key = document.createElement("div");
      key.className = "kbd-key";
      key.textContent = char;
      key.onclick = (evt) => {
        //console.log("click", evt);
        // prevent body click
        evt.stopImmediatePropagation();

        var pos = input.selectionStart ? input.selectionStart : 0;
        var text = input.value;
        text = text.substring(0, pos) + char + text.substring(pos);
        input.value = text;
        input.selectionEnd = input.selectionStart = pos + 1;
        input.focus();
      };
      key.onmousedown = (evt) => {
        key.classList.add("pressed");
      };
      key.onmouseup = (evt) => {
        key.classList.remove("pressed");
      };
      kbd.append(key);
    });
    return kbd;
  }

  /* function submitTest(btn) {
    btn.style.display = "none";
    document.getElementById("spinner").style.display = "block";
    document.testForm.submit();
  } */

  return {
    init: init,
    // submitTest : submitTest,
  };
})();
